import { UserNameInformation } from "./user-name-information";

type ApplicationInitiatorFieldProps = {
  initiatorName: string;
  initiatorEmail?: string | null;
};

export const ApplicationInitiatorField = ({ initiatorName, initiatorEmail }: ApplicationInitiatorFieldProps) => (
  <UserNameInformation name={initiatorName} email={initiatorEmail} />
);
